<i18n locale="en">
{
  "defaults": {
    "select": "Select one",
    "multi-select": "Select more than one"
  }
}
</i18n>

<template>
  <PreviewSheet class="select-preview" border="primary" radius="0">
    <div class="flex-col gap-2">
      <div class="flex-row">
        <PreviewTypographyLegacy :text="label" variant="titleSmall" />
        <PreviewTypographyLegacy
          v-if="required"
          text="*"
          variant="titleSmall"
          color="danger"
        />
      </div>
      <div class="select-preview__option-row flex-col">
        <div
          v-for="(option, index) in options"
          :key="index"
          class="align-center flex-row gap-1"
        >
          <PreviewSheet
            class="select-preview__marker"
            :radius="type === 'select' ? 'medium' : '0'"
            border="divider"
          />
          <PreviewTypographyLegacy :text="option" variant="paragraphRegular" />
        </div>
      </div>
    </div>
  </PreviewSheet>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'

import PreviewTypographyLegacy from '@/lib/builder/public/preview/legacy/PreviewTypographyLegacy.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'

export default {
  name: 'SelectPreview',
  components: {
    PreviewSheet,
    PreviewTypographyLegacy,
  },
  props: {
    content: { type: Object, required: true },

    /**
     * Override data for out of module rendering contexts
     */
    populatedData: { type: Object, default: undefined },
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  computed: {
    ...mapGetters({
      blockById: 'formBuilder/blockById',
    }),
    currentBlock() {
      const { content, populatedData } = this

      return populatedData ?? content
    },
    label() {
      const { currentBlock, type } = this

      return currentBlock?.params?.label || this.t(`defaults.${type}`)
    },
    options() {
      const { currentBlock } = this

      return currentBlock?.params?.options ?? []
    },
    required() {
      const { currentBlock } = this

      return currentBlock?.params?.required
    },
    type() {
      const { currentBlock } = this

      return currentBlock?.type
    },
  },
}
</script>

<style lang="scss" scoped>
.select-preview {
  padding: 12px 40px;

  &__option-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
  }

  &__marker {
    width: 18px;
    height: 18px;
  }
}
</style>
